import OuterWrapper from 'components/wrappers/OuterWrapper';
import React from 'react';

function PageError(): JSX.Element {
  return (
    <OuterWrapper>
      <div className='h-full w-full flex flex-col justify-center items-center px-4 gap-4 text-gray-700 dark:text-gray-400'>
        <h1 className='font-medium text-xl'>Oeps, we cannot run the application</h1>
        <p>The application encountered an error and cannot run. Please try again later or contact our support</p>
      </div>
    </OuterWrapper>
  );
}

export default PageError;
